<template>
  <v-container fluid class="pa-0 ma-0">
    <Historico />
  </v-container>
</template>

<script>
import Historico from "../components/Historico";
export default {
  components: {
    Historico,
  },
  data: () => ({
    tab: null,
  }),
};
</script>